import React from 'react';

interface FormInputProps {
    label?: React.ReactNode;
    name: string;
    id?: string;
    /** Text-shaped types only — numeric/currency fields use NumberInput/CurrencyInput instead, which
     *  always parse to a number rather than relying on a caller-supplied `type` to opt in. */
    type?: 'text' | 'email' | 'tel' | 'date' | 'month';
    value: string | number | null | undefined;
    onChange: (name: string, value: string) => void;
    className?: string;
    disabled?: boolean;
    placeholder?: string;
}

const FormInput = ({ label, name, id, type = 'text', value, onChange, className, disabled, placeholder }: FormInputProps) => {
    // `id` defaults to `name` for the common case (one field per page), but callers rendering the
    // same field repeatedly per row in a list (e.g. one asset/liability among several of the same
    // shape) MUST pass a row-unique `id` — a duplicate id breaks `<label for>` (clicking a label
    // can focus the wrong row's input) and is invalid HTML regardless.
    const domId = id || name;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(name, e.target.value);
    };

    return (
        <div className={className}>
            <label htmlFor={domId} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
            <input
                type={type}
                id={domId}
                name={name}
                value={value ?? ''}
                onChange={handleChange}
                className="w-full px-4 py-2 bg-white/80 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={disabled}
                placeholder={placeholder}
            />
        </div>
    );
};

export default FormInput;
